var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    ref: "modal",
    attrs: {
      variant: "external-link",
      "cta-action": _vm.openExternalLink,
      "cta-text": _vm.ctaText,
      "cta-disabled": _vm.isLoading,
      "custom-class": _vm.isLoading ? "loading" : undefined,
    },
    on: { close: _vm.clear },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
              _vm.innerBody
                ? _c("div", {
                    key: "body",
                    domProps: { innerHTML: _vm._s(_vm.innerBody) },
                  })
                : _vm.errors.length > 0
                ? _c("div", { key: "errors" }, [
                    _c("div", { staticClass: "error-box" }, [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.errorsTemplate) },
                      }),
                    ]),
                  ])
                : _c("div", { key: "loading", staticClass: "loading-data" }, [
                    _c("span", { staticClass: "icon-loading" }),
                  ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }